import Vue from 'vue'
import app from './Onboarding.vue'
import VueCookie from 'vue-cookie'
import axios from 'axios'

const castleblack = axios.create({
  baseURL: `/`
})

castleblack
  .get(`/feature/flag/cxp-onboarding-banner/`)
  .then(response => {
    if (response && response.data['cxp-onboarding-banner'] === true) {
      if (!window._babelPolyfill) {
        require('@babel/polyfill')
      }

      Vue.use(VueCookie)

      new Vue({
        el: '#onboarding-flow',
        render: h => h(app)
      })
    }
  })
  .catch(error => {
    window.console.error(error)
  })
